import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { compose } from 'redux'
import { List, ListItem, ListDivider } from 'react-toolbox/lib/list'
import { Card, CardTitle } from 'react-toolbox/lib/card'
import { Button } from 'react-toolbox/lib/button'
import Input from 'react-toolbox/lib/input'
import { Flex, Box } from 'reflexbox'
import { Avatar } from 'react-toolbox/lib/avatar'

import CSSModules from 'helpers/CSSModulesUtil'
import Divider from 'components/fulcrum/divider/Divider'
import { getDateString } from 'helpers/DateUtil'
import CommentBox from 'components/custom/Comments/CommentBox'
import CommentItem from 'components/custom/Comments/CommentItem'
import Collapse from 'components/fulcrum/collapse/Collapse'
import PanelSectionHeader from 'components/fulcrum/panelSectionHeader/PanelSectionHeader'
import PanelSection from 'components/fulcrum/panelSection/PanelSection'
import progressBarHoc from 'containers/Async/AsyncProgressBar'

import {
  FETCH_COMMENTS,
} from './constants'
import {
  postWorkflowComment as postComment,
} from './actions'
import {
  commentsSelector,
} from './selectors'
import {
  currentApprovalSelector,
} from 'containers/Approval/ApprovalPage/selectors'

import styles from './styles.scss'

const mapStateToProps = state => {
  return {
    currentApproval: currentApprovalSelector(state),
    comments: commentsSelector(state),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    postComment: (workflowId, comment) => dispatch(postComment(workflowId, comment)),
  }
}

const ProgressBar = progressBarHoc([FETCH_COMMENTS])

class CommentSection extends Component {
  static propTypes = {
    comments: PropTypes.array.isRequired,
    postComment: PropTypes.func.isRequired
  }

  constructor(props){
    super(props)
    this.state = {
      collapse: false
    }
  }

  toggleCollapse(){
    this.setState(
      {
        ...this.state,
        collapse: !this.state.collapse
      }
    )
  }

  createComments(){
    return this.props.comments.reduce((componentList, value) => {
      const {
        username,
        name,
        comment,
        id,
        date,
        image
      } = value

      return componentList.concat([
        <CommentItem
          key={id}
          image={image}
          name={name}
          comment={comment}
          date={date}
        />,
        <ListDivider key={'divider_' + id}/>
      ])
    }, [])
  }

  createComment = () => {
    return (comment) => {
      const {
        postComment,
      } = this.props
      const {
        workflowId,
      } = this.props.currentApproval

      postComment(workflowId, comment)
    }
  }

  render() {
    return (
      <PanelSection>
        <PanelSectionHeader label='Comments Section'/>
        <Card>
          <div styleName='buttonContainer'>
            <Button
              flat
              icon={this.state.collapse ? 'expand_more' : 'expand_less'}
              label={this.state.collapse ? 'Show comments' : 'Hide comments'}
              theme={styles}
              onClick={() => this.toggleCollapse()}
            />
          </div>
          <Collapse collapse={this.state.collapse}>
            <Divider/>
            <ProgressBar/>
            <List>
              { this.createComments() }
            </List>
          </Collapse>
          <CommentBox onSubmit={ this.createComment() }/>
        </Card>
      </PanelSection>
    )
  }
}

const withStyles = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withConnect,
  withStyles
)

export default enhance(CommentSection)
